<template>
  <!-- Product Detail：由原 ProductDialog 弹窗改造为页面式分区，样式与 General Information 一致（无附件，内容占满整块）。
       高度同 General/Product List：视口全高、标题栏固定、表单区内部滚动，由本组件自行测量（不依赖父组件传值）。 -->
  <div class="product-detail-wrap" :style="{ height: contentHeight ? contentHeight + 'px' : 'auto' }" v-loading="allLoading" element-loading-background="rgba(255,255,255,0.5)">
    <div class="line-title">
      <span class="text">{{ title }}</span>
      <div class="btn-group">
        <div class="continuous-btn-no-bg" v-if="canEdit">
          <div class="btn" @click="handleSave">Save</div>
          <div class="btn btn-icon" v-if="!isNewProduct" @click="handleDelete">
            <span class="iconfont icon-delete">&#xec7b;</span>
          </div>
        </div>
        <div class="continuous-btn-with-bg" v-if="!isNewProduct">
          <div class="btn btn-icon" @click="handleRefresh">
            <span class="iconfont icon-refresh">&#xe611;</span>
          </div>
        </div>
      </div>
    </div>
    <el-form class="form" :model="form" ref="productForm" label-width="0" :rules="rules">
      <div class="form-wrap">
        <div class="inline-wrap">
          <div class="suqare">
            <div class="title"><span class="asterisk">*</span>Product Type</div>
            <el-form-item prop="productType">
              <el-select @change="changeProductType" size="mini" v-model="form.productType" class="inp" popper-class="opp-select-popper" placeholder="Please select">
                <el-option
                  v-for="item in enumerate.oppProductType"
                  :key="item.code"
                  :label="item.nameEn"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <div class="inline-wrap" v-if="form.productType == 'NPI'">
          <div class="suqare">
            <div class="title">NPI Description</div>
            <el-form-item prop="npiDesc">
              <el-input
                size="mini"
                :autosize="{ minRows: 1 }"
                type="textarea"
                class="inp"
                v-model="form.npiDesc">
              </el-input>
            </el-form-item>
          </div>
        </div>

        <div class="inline-wrap" v-if="form.productType!='NPI'">
          <div class="suqare">
            <div class="title"><span class="asterisk">*</span>Product Description</div>
            <el-form-item prop="productName">
              <div class="search-wrap">
                <el-input class="inp not-allow" :autosize="{ minRows: 1}" type="textarea" size="mini" readonly v-model="form.productName"></el-input>
                <span class="iconfont icon-search" @click="showProductSearch">&#xe622;</span>
              </div>
            </el-form-item>
          </div>
        </div>

        <div class="inline-wrap" v-if="form.productType!='NPI'">
          <div class="suqare">
            <div class="title">Model</div>
            <el-form-item prop="model">
              <el-input disabled size="mini" v-model="form.model" class="inp"></el-input>
            </el-form-item>
          </div>
        </div>

        <div class="inline-wrap" v-if="form.productType!='NPI'">
          <div class="suqare">
            <div class="title"><span class="asterisk" v-if="form.productType !== 'NPI'">*</span>EAN10</div>
            <el-form-item prop="ean">
              <el-input disabled size="mini" v-model="form.ean" class="inp"></el-input>
            </el-form-item>
          </div>
        </div>

        <div class="inline-wrap" v-show="false">
          <div class="suqare">
            <div class="title">9 Part No.</div>
            <el-form-item prop="product9">
              <el-input disabled size="mini" v-model="form.product9" class="inp"></el-input>
            </el-form-item>
          </div>
        </div>

        <div class="inline-wrap" v-show="false">
          <div class="suqare">
            <div class="title">IC</div>
            <el-form-item prop="ic">
              <el-input disabled size="mini" v-model="form.ic" class="inp"></el-input>
            </el-form-item>
          </div>
        </div>

        

        <div class="inline-wrap">
          <div class="suqare">
            <div class="title"><span class="asterisk">*</span>Avg. Unit Price (Inc. Tax)</div>
            <el-form-item prop="priceWithTax">
              <el-input-number
                :controls="false"
                size="mini"
                :precision="4"
                :step="1"
                v-model="form.priceWithTax"
                @change="changePriceWithTax"
                class="inp">
              </el-input-number>
            </el-form-item>
          </div>
        </div>

        <div class="inline-wrap">
          <div class="suqare">
            <div class="title"><span class="asterisk">*</span>Avg. Unit Price (Exc. Tax)</div>
            <el-form-item prop="priceWithoutTax">
              <el-input-number
                size="mini"
                :controls="false"
                :precision="4"
                :step="1"
                v-model="form.priceWithoutTax"
                @change="changePriceWithoutTax"
                class="inp">
              </el-input-number>
            </el-form-item>
          </div>
        </div>

        <div class="inline-wrap">
          <div class="suqare">
            <div class="title">Tax Rate</div>
            <el-form-item prop="taxRate">
              <el-input disabled size="mini" v-model="form.taxRate" class="inp"></el-input>
            </el-form-item>
          </div>
        </div>

        <!-- 占位的 -->
        <div class="inline-wrap">
          <div class="suqare"> 
          </div>
        </div>

        <div class="inline-wrap">
          <div class="suqare">
            <div class="title"><span class="asterisk">*</span>Est. Annual Qty</div>
            <el-form-item prop="annualQty">
              <el-input-number
                size="mini"
                :controls="false"
                :precision="0"
                :step="1"
                v-model="form.annualQty"
                class="inp">
              </el-input-number>
            </el-form-item>
          </div>
        </div>

        <div class="inline-wrap">
          <div class="suqare">
            <div class="title"><span class="asterisk">*</span>Est. Project Period Qty</div>
            <el-form-item prop="projectQty">
              <el-input-number
                size="mini"
                :controls="false"
                :precision="0"
                :step="1"
                v-model="form.projectQty"
                class="inp">
              </el-input-number>
            </el-form-item>
          </div>
        </div>

        <div class="inline-wrap">
          <div class="suqare">
            <div class="title"><span class="asterisk">*</span>Est. Delivery Start</div>
            <el-form-item prop="deliveryStart">
              <el-date-picker
                size="mini"
                v-model="form.deliveryStart"
                class="inp"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                :picker-options="startDateOptions"
                type="date">
              </el-date-picker>
            </el-form-item>
          </div>
        </div>

        <div class="inline-wrap">
          <div class="suqare">
            <div class="title"><span class="asterisk">*</span>Est. Delivery End</div>
            <el-form-item prop="deliveryEnd">
              <el-date-picker
                size="mini"
                v-model="form.deliveryEnd"
                class="inp"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                :picker-options="endDateOptions"
                type="date">
              </el-date-picker>
            </el-form-item>
          </div>
        </div>

        <!-- Comment：整行文本域，样式同 General Information 的 Competitor Information/Other Project Remarks -->
        <div class="inline-wrap inline-wrap-long">
          <div class="suqare">
            <div class="title">Comment</div>
            <el-form-item prop="comment">
              <el-input
                size="mini"
                :autosize="{ minRows: 3 }"
                type="textarea"
                class="inp"
                v-model="form.comment">
              </el-input>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
    <!-- Product Search 选择弹窗：点 Product Description 放大镜打开，选中后回填 productName/model/ean -->
    <ProductSearch ref="productSearch" @select="getProductFromDialog" />
  </div>
</template>

<script>
import selectMixin from '@/mixins/selectMixins'
import ProductSearch from '@/components/ProductSearch'
import {postAction, getAction} from '@/api/tool'
import {api_opp_product_add, api_opp_product_update, api_opp_product_delete, api_opp_product_detail} from '@/api/api'
export default {
  name:'ProductDetail',
  mixins:[selectMixin],
  components:{
    ProductSearch
  },
  props:{
    //产品数据（父组件按 opportunityLineId 唯一标识传入）；新增时可为空对象
    data:{
      type:Object,
      default:()=>({})
    },
    //Product Type 下拉数据源，由父组件传入 enumerate.oppProductType
    productTypeOptions:{
      type:Array,
      default:()=>[]
    },
    //所属商机编号：新增/编辑/删除接口均需将其作为 URL 参数传给后端
    oppNo:{
      type:String,
      default:''
    },
    //是否可编辑产品（控制 Save/Delete 按钮组显示）：由父组件传 form.status==10（仅 Open 状态可编辑）
    canEdit:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
      //整块 loading：保存/刷新/删除时置真（模板根节点 v-loading="allLoading"）
      allLoading:false,
      //表单区可用高(px)：本组件自行测量，不依赖父组件传值（同 ProductList 的做法）
      contentHeight:0,
      form:{
        opportunityLineId:'',
        productType:'',
        productName:'',
        model:'',
        ic:'',
        ean:'',
        product9:'',
        priceWithTax:undefined,
        priceWithoutTax:undefined,
        taxRate:'13%',
        annualQty:undefined,
        projectQty:undefined,
        deliveryStart:'',
        deliveryEnd:'',
        npiDesc:'',
        comment:'',
        ...(this.data || {})
      },
      rules:{
        annualQty:[
          {required:true, message:'Complete this field.', trigger:'change'}
        ],
        projectQty:[
          {required:true, message:'Complete this field.', trigger:'change'}
        ],
        deliveryStart:[
          {required:true, message:'Complete this field.', trigger:'change'}
        ],
        deliveryEnd:[
          {required:true, message:'Complete this field.', trigger:'blur'}
        ],
        priceWithTax:[
          {required:true, message:'Complete this field.', trigger:'blur'}
        ],
        priceWithoutTax:[
          {required:true, message:'Complete this field.', trigger:'blur'}
        ],
        productType:[
          {required:true, message:'Complete this field.', trigger:'blur'}
        ],
        ean:[
          //EAN10：仅当 productType 不为 NPI 时必填（NPI 时由用户手录产品名，无 EAN10）
          {
            validator:(rule, value, callback)=>{
              if(this.form.productType !== 'NPI' && (value === undefined || value === null || value === '')){
                callback(new Error('Complete this field.'))
              }else{
                callback()
              }
            },
            trigger:'blur'
          }
        ],
        productName:[
          {required:true, message:'Complete this field.', trigger:'blur'}
        ]
      },
    }
  },
  computed:{
    /* 有 opportunityLineId 视为编辑既有产品，否则为新增 */
    title(){
      return this.form.opportunityLineId ? 'Product Information' : 'New Product Information'
    },
    /* 新增态（无 opportunityLineId）：删除/刷新按钮无意义，隐藏 */
    isNewProduct(){
      return !this.form.opportunityLineId
    },
    /* Start Date 限制：不能晚于已选的 End Date（未选 End 时不限制） */
    startDateOptions(){
      return {
        disabledDate: (time)=>{
          if(!this.form.deliveryEnd){
            return false
          }
          return time.getTime() > this.parseLocalDate(this.form.deliveryEnd)
        }
      }
    },
    /* End Date 限制：必须等于或晚于已选的 Start Date（未选 Start 时不限制） */
    endDateOptions(){
      return {
        disabledDate: (time)=>{
          if(!this.form.deliveryStart){
            return false
          }
          return time.getTime() < this.parseLocalDate(this.form.deliveryStart)
        }
      }
    }
  },
  watch:{
    //父组件切换/回填数据时同步到本地表单
    data(val){
      this.form = { ...this.form, ...(val || {}) }
    }
  },
  methods:{
    changeProductType(){
      this.form.productName = ''
      this.form.model = ''
      this.form.ean = ''
      this.form.product9 = ''
      this.form.ic = ''
      this.form.npiDesc = ''
    },
    /* 价格联动：税率固定 13%。含税 = 不含税 × 1.13，不含税 = 含税 ÷ 1.13，结果保留 4 位小数（同字段 :precision="4"）。
       两个方法分别绑定到对应 el-input-number 的 @change，仅在用户输入时触发；程序回填另一字段不会再次触发 change，故不会死循环。 */
    round4(num){
      return Math.round(num * 10000) / 10000
    },
    /* 将 'yyyy-MM-dd' 按本地时区解析为当天零点时间戳（避免 new Date(str) 按 UTC 解析导致跨时区差一天） */
    parseLocalDate(str){
      let parts = String(str).split('-')
      return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])).getTime()
    },
    changePriceWithTax(val){
      if(val === undefined || val === null || val === ''){
        this.form.priceWithoutTax = undefined
        return
      }
      this.form.priceWithoutTax = this.round4(val / 1.13)
    },
    changePriceWithoutTax(val){
      if(val === undefined || val === null || val === ''){
        this.form.priceWithTax = undefined
        return
      }
      this.form.priceWithTax = this.round4(val * 1.13)
    },
    /* 计算可用高：视口高 − 固定头部(.head-wrap) − 吸顶头(.detail-sticky-head) − 底部间距常量 30。
       常量 30 与 Detail/index.vue、ProductList.vue 保持一致，使各分区底部留白统一。 */
    handleResize(){
      this.$nextTick(()=>{
        let headEl = document.querySelector('.head-wrap')
        let headHeight = headEl ? headEl.offsetHeight : 0
        let stickyEl = document.querySelector('.detail-sticky-head')
        let stickyH = stickyEl ? stickyEl.offsetHeight : 0
        let h = window.innerHeight - headHeight - stickyH - 30
        this.contentHeight = h > 200 ? h : 200
      })
    },
    /* 打开 Product Search 弹窗：弹窗内部永远从空状态开始（不带入外部值、不自动勾选） */
    showProductSearch(){
      this.$refs.productSearch.open()
    },
    /* Product Search 弹窗选择回调：回填 Product Description/Model/EAN10（弹窗 productName/model/ean → 本页同名字段） */
    getProductFromDialog(item){
      this.form.productName = item.productName || ''
      this.form.model = item.model || ''
      this.form.ean = item.ean || ''
      //EAN10 为必填项，选完清掉可能存在的校验错误提示
      this.$nextTick(()=>{
        if(this.$refs.productForm){
          this.$refs.productForm.clearValidate('ean')
        }
      })
    },
    /* 保存：有 opportunityLineId 走编辑(update)，否则走新增(add)；oppNo 均放在 URL 参数 */
    handleSave(){
      this.$refs.productForm.validate((valid)=>{
        if(!valid){
          return
        }
        let payload = { ...this.form }
        //taxRate 仅前端展示，后端不收
        delete payload.taxRate
        let isEdit = !!this.form.opportunityLineId
        let url = (isEdit ? api_opp_product_update : api_opp_product_add) + '?oppNo=' + encodeURIComponent(this.oppNo || '')
        this.allLoading = true
        postAction(url, payload).then(res=>{
          this.allLoading = false
          if(!isEdit && res){
            let newId = res.opportunityLineId
            if(newId){
              this.form.opportunityLineId = newId
            }
          }
          this.$message.success(this.L.operateSuccess)
          this.$emit('saved', { ...this.form })
          //产品新增/编辑成功后通知商机列表页(被 keep-alive 缓存，监听常驻)刷新
          this.$root.$emit('opportunitySaved')
        }).catch(()=>{
          this.allLoading = false
        })
      })
    },
    /* 刷新：GET api_opp_product_detail，参数 opportunityLineId，回填当前表单 */
    handleRefresh(){
      if(!this.form.opportunityLineId){
        return
      }
      this.allLoading = true
      getAction(api_opp_product_detail, { opportunityLineId: this.form.opportunityLineId }).then(detail=>{
        this.allLoading = false
        if(detail){
          this.form = { ...this.form, ...detail }
        }
      }).catch(()=>{
        this.allLoading = false
      })
    },
    /* 删除：POST api_opp_product_delete，oppNo 放 URL 参数，opportunityLineId 放请求体 */
    handleDelete(){
      if(!this.form.opportunityLineId){
        //未保存的新增产品，直接通知父组件关闭页签
        this.$emit('deleted', { opportunityLineId: '' })
        return
      }
      this.$confirm(`Are you sure to delete product 【${this.form.productName || this.form.npiDesc}】?`, 'Delete Product', {
        confirmButtonText: this.promptConfirmBtn,
        cancelButtonText: this.propmtCancelBtn,
        type: 'warning'
      }).then(()=>{
        let url = `${api_opp_product_delete}?oppNo=${this.oppNo}&opportunityLineId=${this.form.opportunityLineId}`
        this.allLoading = true
        postAction(url).then(()=>{
          this.allLoading = false
          this.$message.success(this.L.operateSuccess)
          this.$emit('deleted', { opportunityLineId: this.form.opportunityLineId })
          //产品删除成功后通知商机列表页(被 keep-alive 缓存，监听常驻)刷新
          this.$root.$emit('opportunitySaved')
        }).catch(()=>{
          this.allLoading = false
        })
      }).catch(()=>{})
    }
  },
  mounted(){
    this.getOppSelect()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('load', this.handleResize)
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('load', this.handleResize)
  }
}
</script>

<style lang="less" scoped>
@import url('/public/css/public.less');
/* 本页局部变量：取值与 Detail/index.less 的 General Information 表单保持一致，确保两处样式一模一样 */
@inpWholeWrap:448px;
@inpTitle:206px;
@inpTextColor:#444444;
@inpDarkBorder:#a6a6a6;
@inpDisabledBorder:#c9c9c9;
@inpDisabledBg:#f3f3f3;
@dateIconColor:#9f3c00;
@inpFontFamily: apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", Helvetica, "PingFang SC", "Meiryo UI", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif;

/* 外框：全高、白底卡片（同 General 的 .general-data-left），标题栏固定 + 表单区内部滚动；无附件，占满整块宽度 */
.product-detail-wrap{
  margin-top: 14px; /* 与 General/Product List 区块一致的顶部间距 */
  text-align: left;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background-color: #fff;
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 0 6px 10px 4px rgba(228, 225, 223, 0.5);
  /* 分区标题栏 - 照抄 General Information 的 .line-title */
  .line-title{
    min-height: 40px;
    flex-shrink: 0;
    padding: 0 14px;
    background-color: @lightOrange;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .text{
      font-weight: 600;
    }
    .btn-group{
      display: flex;
      align-items: center;
    }
  }
  /* 表单区：占满剩余高度并独立滚动（同 General 的 .general-data-left > .form） */
  .form{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    margin-top: 10px;
    .form-wrap{
      padding:0 0 14px 14px;
      width:100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      box-sizing: border-box;
      column-gap: 16px;
      .inline-wrap{
        margin-top:8px;
        margin-right: 14px;
        flex: 1 1 @inpWholeWrap;
        min-width: 0;
        .suqare{
          display: flex;
          align-items: center;
          .title{
            width:@inpTitle;
            flex-shrink: 0;
            line-height: 15px;
            font-size: 12px;
            color:@inpTextColor;
            margin-bottom:0px;
            text-align: left;
            .asterisk{
              color:@dangerColor;
              margin-right: 4px;
              font-weight: 600;
            }
          }
          .el-form-item{
            flex:1;
            margin-bottom: 0px;
          }
          /* Product Description 的放大镜容器（照抄 Detail/index.less .search-wrap）：只读白底 input + 右侧绝对定位放大镜 */
          .search-wrap{
            width:100%;
            position: relative;
            .icon-search{
              position: absolute;
              top: 50%;
              right: 8px;
              transform: translateY(-50%);
              font-size: 17px;
              color: @mainColor; /* 与 cqm2 放大镜同色 */
              &:hover{
                cursor: pointer;
              }
            }
          }
          /* 只读 input 光标示意不可输入，引导用户点放大镜选择 */
          ::v-deep .not-allow .el-input__inner{
            cursor: not-allowed;
          }
          ::v-deep .el-form-item__content{
            line-height:normal;
          }
          .inp{
            width:100%;
          }
        }
      }
      .inline-wrap-long{
        flex: 1 1 100%;
      }
    }
    /* input / select / date 的边框、文字颜色，与 General Information 一致 */
    ::v-deep .el-input__inner{
      border:1px solid @inpDarkBorder;
      border-radius: 4px;
      color:@mainFontColor;
      font-size: 13px;
      font-family:@inpFontFamily;
      padding:0 8px;
    }
    ::v-deep .el-input--mini .el-input__inner{
      height:32px;
      line-height:32px;
    }
    ::v-deep .el-input.is-disabled .el-input__inner{
      background-color:@inpDisabledBg;
      border-color:@inpDisabledBorder;
      color:@mainFontColor;
      cursor:not-allowed;
    }
    ::v-deep .el-input__inner:focus{
      border-color:@mainColor;
    }
    ::v-deep .el-select .el-input.is-focus .el-input__inner{
      border-color:@mainColor;
    }
    /* 日期选择器图标样式 */
    ::v-deep .el-date-editor{
      width:100%;
      display:inline-block;
    }
    ::v-deep .el-date-editor .el-input__inner{
      padding-left:30px;
      padding-right:8px;
    }
    ::v-deep .el-date-editor .el-input__icon{
      height:100%;
      width:25px;
      text-align:center;
      line-height:32px;
      font-size:13px;
      color:@dateIconColor;
    }
    /* 数字输入框：文字左对齐、无控制按钮时的内边距 */
    ::v-deep .el-input-number .el-input__inner{
      text-align:left;
    }
    ::v-deep .el-input-number.is-without-controls .el-input__inner{
      padding:0 8px;
    }
    ::v-deep .el-input-number--mini{
      line-height:32px;
    }
  }
}
</style>
